import * as React from 'react'
import PropTypes from 'prop-types'
import {
  HeroSection,
  HeaderContainer,
  CTAContainer,
  MobileMediaContainer,
  MediaContainer,
} from './styles'
import CTAButton from '../CTAButton/CTAButton'
import { HeroHeader } from './HeroHeader'
import { HeroMedia } from './HeroMedia'

export default function LPHero({
  headingCopy,
  subHeadlineCopy,
  heroImageUrl = 'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F53dd54d8ac3e42219b8e9a1bba44d054',
  heroImgAlt,
  hasDualCta,
  cta1Text,
  cta1Link,
  cta1Analytics,
  cta1Variant,
  cta2Text,
  cta2Link,
  cta2Analytics,
  cta2Variant,
  isVideo,
  mp4VideoUrl,
}) {
  return (
    <HeroSection>
      <MobileMediaContainer>
        <HeroMedia
          imageUrl={heroImageUrl}
          imageAlt={heroImgAlt}
          isVideo={isVideo}
          videoUrl={mp4VideoUrl}
        />
      </MobileMediaContainer>
      <HeaderContainer>
        <HeroHeader headingCopy={headingCopy} subHeadlineCopy={subHeadlineCopy} />
        <CTAContainer>
          <CTAButton ctaLink={cta1Link} ctaVariant={cta1Variant} ctaAnalytics={cta1Analytics}>
            {cta1Text}
          </CTAButton>
          {hasDualCta && (
            <CTAButton ctaLink={cta2Link} ctaVariant={cta2Variant} ctaAnalytics={cta2Analytics}>
              {cta2Text}
            </CTAButton>
          )}
        </CTAContainer>
      </HeaderContainer>
      <MediaContainer>
        <HeroMedia
          imageUrl={heroImageUrl}
          imageAlt={heroImgAlt}
          isVideo={isVideo}
          videoUrl={mp4VideoUrl}
        />
      </MediaContainer>
    </HeroSection>
  )
}

LPHero.propTypes = {
  headingCopy: PropTypes.string.isRequired,
  subHeadlineCopy: PropTypes.string,
  heroImageUrl: PropTypes.string,
  heroImgAlt: PropTypes.string,
  hasDualCta: PropTypes.bool.isRequired,
  cta1Text: PropTypes.string.isRequired,
  cta1Link: PropTypes.string.isRequired,
  cta1Analytics: PropTypes.string,
  cta1Variant: PropTypes.bool.isRequired,
  cta2Text: PropTypes.string,
  cta2Link: PropTypes.string,
  cta2Analytics: PropTypes.string,
  cta2Variant: PropTypes.bool,
  isVideo: PropTypes.bool.isRequired,
  mp4VideoUrl: PropTypes.string,
}
